import React, { Component } from "react";
import PropTypes from "prop-types";
import { StyledSidebarPanelCloseButton } from "../styled/details/stylesDetails";
import { FaTimes } from "react-icons/fa";
import { Box } from "@chakra-ui/react";

class TldrSidebarCloseAnchor extends Component {
  handleClick = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Box display={["none", "none", "block", "block"]}>
        <StyledSidebarPanelCloseButton
          right={"-42px"}
          onClick={this.handleClick}
        >
          <div className="icon-wrapper">
            <FaTimes />
          </div>
        </StyledSidebarPanelCloseButton>
      </Box>
    );
  }
}

TldrSidebarCloseAnchor.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default TldrSidebarCloseAnchor;
